// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3Rl4P","colMin":"styles_colMin__7FPzs","colCheckbox":"styles_colCheckbox__3mhMJ"};